module.exports = __webpack_public_path__ + "img/icon_logo_1.e0188ad7.png";